import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const SITE = "https://www.creditreform-luzern.ch";

// Canonical und og-Grundwerte fuer jede Route. Seiten und Beitraege setzen Title,
// Description und og:title/og:description selbst, Beitraege ueberschreiben og:type.
export default function SeoDefaults() {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
  const url = SITE + path;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Creditreform Luzern Bannwart AG" />
      <meta property="og:image" content={SITE + "/og-image.png"} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
